import { render, staticRenderFns } from "./EEllipsis.vue?vue&type=template&id=71fd1bca&scoped=true&"
import script from "./EEllipsis.vue?vue&type=script&lang=js&"
export * from "./EEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd1bca",
  null
  
)

export default component.exports